import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["sidebar", "backdrop"];

  declare sidebarTarget: HTMLElement;
  declare backdropTarget: HTMLElement;

  connect() {
    document.addEventListener("turbo:before-cache", this.close);
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.close);
  }

  open = () => {
    this.sidebarTarget.dataset.open = "";
    this.backdropTarget.dataset.open = "";
  };

  close = () => {
    delete this.sidebarTarget.dataset.open;
    delete this.backdropTarget.dataset.open;
  };
}
